import createDetailsSelector from './createDetailsSelector';
import { getFunctionData } from '../getFunctionData';
import { getFunctionAlarmRanges } from '../getFunctionAlarmRanges';
import { getFunctionSensors } from '../getFunctionSensors';

export default createDetailsSelector(getFunctionData, getFunctionAlarmRanges, getFunctionSensors);